import { Box } from '@mui/material';
import StarIcon from '../../../assets/images/icons/star_blue.png';
import PrivilegeImage from '../../../assets/images/pages/privilege/privilege-card.png';
import { useUserStore } from '../../../stores/userStore';
import { addCommaToNumber } from '../../../utils/utils';

const PrivilegeCard = () => {
  const companyInfo = useUserStore((state) => state.companyInfo);
  const point = companyInfo ? addCommaToNumber(companyInfo.accumulated_points) : '0';

  return (
    <Box
      sx={{
        width: '100%',
        height: '220px',
        position: 'relative',
        background: `url(${PrivilegeImage}) center center / cover`,
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 16px',
        }}
      >
        <Box sx={{ fontSize: '2.2rem', lineHeight: '2rem', fontWeight: '500', color: '#005972' }}>
          Privilege
        </Box>
        <Box>
          <Box
            sx={{
              fontSize: '1.5rem',
              lineHeight: '1.5rem',
              fontWeight: '500',
              color: '#005972',
              textAlign: 'right',
            }}
          >
            คะแนนสะสม
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '5px',
              fontSize: '2rem',
              lineHeight: '2rem',
              fontWeight: '500',
              color: '#005972',
            }}
          >
            <Box component="img" src={StarIcon} alt="Star" sx={{ height: '22px' }} />
            {point}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width: '100%',
          fontSize: '1.2rem',
          fontWeight: '500',
          color: '#005972',
          lineHeight: '1.25rem',
          background: 'linear-gradient(to right, rgba(255,255,255,0.19), rgb(255,255,255))',
          textAlign: 'right',
          padding: '2px 16px',
          position: 'absolute',
          bottom: '0',
          left: '0',
        }}
      >
        <p>ศูนย์บริการลูกค้าบัตรสตาร์การ์ด</p>
        <p
          style={{
            fontWeight: '600',
            fontSize: '1.65rem',
            lineHeight: '1rem',
            margin: '4px 0 5px',
          }}
        >
          02-078-3555 กด 2
        </p>
        <p style={{ fontWeight: '400', fontSize: '.85rem', lineHeight: '.8rem' }}>
          ตั้งแต่เวลา 8.00 น. - 20.00 น. ของทุกวัน
        </p>
        <p style={{ fontWeight: '400', fontSize: '.85rem', lineHeight: '.8rem' }}>
          สำหรับสอบถาม / ให้ความช่วยเหลือด้านการใช้งานบัตรสตาร์การ์ด
        </p>
      </Box>
    </Box>
  );
};

export default PrivilegeCard;
